import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import AdminTable from "src/pages/Administrator/Helpers/AdminTable";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import {
  addAbonement,
  editAbonement,
  getAbonementsClient,
  getFrHistory,
} from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";

const AbonementShowFr = ({
  abonementModal,
  setAbonementModal,
  clientInfo,
  abonementInfo,
  title,
  page,
  pageSize,
  setPage,
  setPageSize,
  handleTableChange,
  onClickRowOne,
}) => {
  // HELPERS
  const dispatch = useDispatch();

  // STATE
  const [frHistory, setFrHistory] = useState(null);

  // FUNCTIONS

  const formatedClientsAbonementsRows = frHistory?.data?.value?.rows.map(
    (element) => {
      return {
        ...element,
        frozeStart: element.frozeStart
          ? dayjs(element?.frozeStart).format("DD.MM.YYYY")
          : "",
        frozeEnd: element.frozeEnd
          ? dayjs(element?.frozeEnd).format("DD.MM.YYYY")
          : "",
        creationDate: element.creationDate
          ? dayjs(element?.creationDate).format("DD.MM.YYYY")
          : "",
      };
    }
  );

  useEffect(() => {
    if (abonementModal) {
      dispatch(
        getFrHistory({
          userAbonementId: abonementInfo.id,
          userId: clientInfo.id,
        })
      ).then((result) => {
        // result.payload or result.value — check your thunk return
        setFrHistory(result.payload || result.value || result);
      });
    }
  }, [abonementModal, abonementInfo, clientInfo, dispatch]);

  console.log(frHistory?.data?.value?.rows);

  return (
    <CModal
      size="xl"
      //   sx={{ height: "1000px" }}
      alignment="center"
      visible={abonementModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setAbonementModal(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">{"Заморозки"}</CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <AdminTable
            scroll={{ x: 0, y: 400 }}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            onChange={handleTableChange}
            // loading={getAbonementsClientListLoading}
            // onClickRowOne={onClickRowOne}
            columns={frHistory}
            rows={formatedClientsAbonementsRows}
            total={frHistory?.data?.value?.totalCount}
            // title={title}
            // items={items}
          />
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setAbonementModal(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AbonementShowFr;
